import React, { useRef } from "react";
import { QRCodeSVG } from "qrcode.react";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import logo from "../../../assets/images/ifh-logo.png";
import { FaRegFilePdf } from "react-icons/fa6";

const CarnetAlumno = ({ name, qrValue }) => {
  const carnetRef = useRef();

  const handleDownloadPDF = async () => {
    const element = carnetRef.current;
    const canvas = await html2canvas(element, { scale: 2 });
    const imgData = canvas.toDataURL("image/png");

    const pdf = new jsPDF("portrait", "mm", [54, 85.6]);
    pdf.addImage(imgData, "PNG", 0, 0, 54, 85.6);
    pdf.save(`Carnet-IFH-${name}.pdf`);
  };

  return (
    <>
      <div
        ref={carnetRef}
        style={{
          width: "54mm",
          height: "85.6mm",
          padding: "3mm",
          boxSizing: "border-box",
          backgroundColor: "#ffffff",
          textAlign: "center",
          fontFamily: "Arial, sans-serif",
          position: "absolute",
          top: "-9999px",
          left: "-9999px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "flex-start",
        }}
      >
        <img src={logo} alt="Logo" style={{ width: "20mm", marginBottom: "2mm" }} />
        <p style={{ fontSize: "9pt", margin: "1mm 0" }}>INSTITUTO<br/> FILOSOFICO HERMETICO</p>
        <div style={{ marginTop: "4mm" }}>
          <QRCodeSVG value={qrValue} size={60} level="H" />
          <p style={{ fontSize: "9pt", margin: "2mm 0" }}>Socio</p>
          <h2 style={{ fontSize: "10pt", margin: "2mm 0 2mm 0" }}>{name}</h2>
        </div>
        <p style={{ fontSize: "9pt", margin: "4mm 0" }}>Año 2025</p>
      </div>

      <button onClick={handleDownloadPDF} className="btn btn-primary primaryBtn mt-3" style={{ width: "auto" }}>
        <FaRegFilePdf /> Descargar credencial en PDF
      </button>

    </>
  );
};

export default CarnetAlumno;
